export default "__VITE_ASSET__R3NT7kG5__"